import React from "react";
import "../contactpage.css";

import Footer from "../footer";

export default function ContactPage() {
  const inquiryTypes = [
    {
      title: "Partnerships",
      body: "Work with Commonwealth on infrastructure, origination, servicing, distribution, or strategic integrations.",
    },
    {
      title: "Investors",
      body: "For conversations about the business, vision, and the future of the platform.",
    },
    {
      title: "Press",
      body: "Media requests, interviews, speaking opportunities, and commentary.",
    },
    {
      title: "Builders",
      body: "Engineers, designers, and operators who want to help build what comes next.",
    },
    {
      title: "General",
      body: "Thoughtful questions, introductions, ideas, and everything else.",
    },
  ];

  return (
    <main className="contactPage">
      <section className="contactHero">
        <div className="contactHero__glow" />
        <div className="contactHero__inner">
          <p className="contactHero__eyebrow">CONTACT</p>

          <h1 className="contactHero__title">Talk to Commonwealth.</h1>

          <p className="contactHero__subtitle">
            If you’re serious about the future of finance, reach out.
          </p>
        </div>
      </section>

      <section className="contactMain">
        <div className="contactMain__inner">
          <div className="contactMain__grid">


            <div className="contactFormWrap">
              <div className="contactFormGlass" />

              <div className="contactFormCard">
                <p className="contactFormCard__label">Start the conversation</p>

                <form className="contactForm">
                  <div className="contactForm__row">
                    <div className="contactField">
                      <label htmlFor="name">Name</label>
                      <input
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Your name"
                      />
                    </div>

                    <div className="contactField">
                      <label htmlFor="email">Email</label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="you@company.com"
                      />
                    </div>
                  </div>

                  <div className="contactField">
                    <label htmlFor="role">You are...</label>
                    <select id="role" name="role" defaultValue="">
                      <option value="" disabled>
                        Select one
                      </option>
                      <option value="investor">Investor</option>
                      <option value="partner">Partner</option>
                      <option value="press">Press</option>
                      <option value="builder">Builder</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div className="contactField">
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="7"
                      placeholder="What should we know?"
                    />
                  </div>

                  <button type="submit" className="contactForm__submit">
                    Start the conversation
                  </button>
                </form>

                <div className="contactDirect">
                  <p className="contactDirect__label">Direct</p>

                  <div className="contactDirect__links">
                    <a href="mailto:hello@commonwealth.com">hello@commonwealth.com</a>
                    <a
                      href="https://x.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      X / Twitter
                    </a>
                    <a
                      href="https://www.linkedin.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      LinkedIn
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="contactClosing">
            <p>Beyond the banks.</p>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
